<template>
  <div class="client">
    <b-alert
      :show="dismissCountDown"
      :variant="variant"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
      >{{ message }}</b-alert
    >
    <form @submit.prevent="addUser()">
      <h5>Cliente</h5>

      <div class="row">
        <div class="col-12">
          <div class="searchClient">
            <input
              v-model="form.email"
              id="email"
              type="text"
              class="form-control form-control-sm w80"
              placeholder="Ingresa email"
              required
            />
            <button class="btn btn-primary btn-block w20" @click.prevent="getUserValid">
              Buscar
            </button>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="name" class="mb-1">Nombres</label>
            <input
              v-model="form.firstName"
              id="name"
              type="text"
              class="form-control form-control-sm"
              :disabled="disabled"
              required
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="lastname" class="mb-1">Apellidos</label>
            <input
              v-model="form.lastName"
              id="lastname"
              type="text"
              class="form-control form-control-sm"
              :disabled="disabled"
              required
            />
          </div>
        </div>

        <div class="col-6">
          <div class="form-group">
            <label for="documentType" class="mb-1">Tipo documento</label>
            <select
              v-model="form.documentType"
              id="documentType"
              class="form-control form-control-sm"
              :disabled="disabled"
              required
            >
              <option value="">Seleccionar</option>
              <option value="DNI">DNI</option>
              <option value="RUC">RUC</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="document" class="mb-1">Nº documento</label>
            <input
              v-model="form.document"
              id="document"
              class="form-control form-control-sm"
              type="text"
              :minlength="form.documentType === 'DNI' ? 8 : 6"
              :maxlength="form.documentType === 'DNI' ? 8 : 15"
              :disabled="disabled"
              required
              @keypress="isNumber"
            />
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-primary ml-3"
          :disabled="disabled"
          v-if="isDeliveryProccess"
        >
          Crear
        </button>
      </div>
    </form>
    <hr />
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        documentType: '',
        document: ''
      },
      disabled: true,
      dismissSecs: 3,
      dismissCountDown: false,
      message: '',
      variant: ''
    };
  },
  watch: {
    showAlert(value) {
      if (value) {
        this.dismissCountDown = this.dismissSecs;
        this.variant = this.alert.variant;
        this.message = this.alert.message;
      }
    }
  },
  computed: {
    getCustomer() {
      return this.$store.getters.getCustomer;
    },
    isDeliveryProccess() {
      return this.$store.getters.getIsDeliveryProccess;
    },
    showAlert() {
      return this.$store.getters.showAlert;
    },
    alert() {
      return this.$store.getters.alert;
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if (this.dismissCountDown === 0) {
        this.dismissCountDown = false;
      }
    },
    isNumber(val) {
      if (isNaN(Number(val.key))) {
        return val.preventDefault();
      }
    },
    changeValues() {
      const isCustomer = this.$store.getters.getCustomer;
      if (!isCustomer) {
        this.disabled = false;
        this.form.firstName = '';
        this.form.lastName = '';
        this.form.documentType = '';
        this.form.document = '';
      } else {
        this.disabled = true;
        this.form.firstName = isCustomer.firstName;
        this.form.lastName = isCustomer.lastName;
        this.form.documentType = isCustomer.documentType;
        this.form.document =
          isCustomer.documentType === 'DNI' ? isCustomer.dniUser : isCustomer.rucDni;
      }
    },
    async addUser() {
      const payload = this.form;
      payload.brandId = 1;
      try {
        await this.$store.dispatch('createUser', payload);
      } catch (error) {
        console.log(error);
      }
    },
    async getUserValid() {
      if (this.form.email) {
        try {
          await this.$store.dispatch('getUserValid', this.form.email.toString());
          this.changeValues();
        } catch (error) {
          console.log(error);
        }
      }
    },
    setDefaultValues() {
      this.disabled = true;
      this.form.email = this.getCustomer ? this.getCustomer.email : '';
      this.form.firstName = this.getCustomer ? this.getCustomer.firstName : '';
      this.form.lastName = this.getCustomer ? this.getCustomer.lastName : '';
      this.form.documentType = this.getCustomer ? this.getCustomer.documentType : 'DNI';
      if (this.getCustomer) {
        this.form.document =
          this.getCustomer.documentType === 'DNI'
            ? this.getCustomer.dniUser
            : this.getCustomer.rucDni;
      }
    }
  },
  mounted() {
    this.setDefaultValues();
  }
};
</script>
<style lang="scss">
.client {
  .searchClient {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .w20 {
    width: 20%;
  }
  .w80 {
    width: 80%;
  }
}
</style>
